/**
 * Created by Jie Gao on 2021-02-22.
 */
import {IScreenConfig, ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {GGGameMode} from "../../gamemode/GGGameMode";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {GoldenGoblins} from "../../GoldenGoblins";
import {TimelineLite} from "gsap";
import {GGGameModuleConfig} from "../../GGGameModuleConfig";

export class GGSuperFreespinIntroController extends ScreenController {
    protected _isRestoreFreespin: boolean;
    protected _isFreespinWon: boolean;
    protected _remainingFreeSpins: number;

    constructor(config: IScreenConfig, tweakEnabled?: boolean) {
        super("SuperFreespinIntro", config, tweakEnabled);
    }

    protected calculateIsTriggered(data: ParsedServerData): boolean {
        const isRestoreState: boolean = (data instanceof ParsedInitData) ? (<ParsedInitData>data).isRestoreState : false;
        const isNextModeFS: boolean = data.nextMode === GGGameMode.FREESPIN_SUPER || data.nextMode === GameMode.FREESPIN;
        this._isFreespinWon = isNextModeFS && (data.mode.indexOf("FREESPIN") < 0);
        this._isRestoreFreespin = isRestoreState && (data.mode.indexOf("FREESPIN") > -1);
        this._remainingFreeSpins = data.freespinsLeft;
        return this._isFreespinWon || this._isRestoreFreespin;
    }

    protected doTransitions() {
    }

    protected onShowComplete(): void {
        this._view.enableButton();
    }

    protected shouldShow(): boolean {
        return this._isFreespinWon || this._isRestoreFreespin;
    }

    // #414
    protected onCloseComplete(): void {
        // This will turn off Autoplay if in restricted jurisdiction
        if (GoldenGoblins.autoPlay.turnOffAutoplayOnBonus) {
            GoldenGoblins.autoPlay.turnOffAutoplayOnBonus();
        }

        const tl: TimelineLite = new TimelineLite({
            onComplete: () => super.onCloseComplete()
        });

        tl.add([
            ()=>GGGameModuleConfig.soundPlayer.playCameraPanningSound(this._isRestoreFreespin),
            GGGameModuleConfig.background.panUpDownEffect(false, this._isRestoreFreespin)
        ]);
    }
}